/* shazory-card-title-rewriter.js — neutralized 2026-05-27.
   Original behavior wrapped every product card title with a fake italic
   prefix (e.g. "The *Blanket* Custom Photo Throw Blanket"). It collided
   with the SEO-optimized titles introduced May 2026 and was killed at
   Tanveer's request. Safe to keep loaded — does nothing now.
*/
(function () { 'use strict'; })();
